@if (corporateTaxEntity$ | async) {
  <form [formGroup]="deelnemingenFg">
    <div formArrayName="deelnemingen">
      @for (item of deelnemingen.controls; track item; let i = $index) {
        <div [formGroupName]="i">
          <div class="row mb-0.5">
            <div class="col-auto">
              <snelstart-ui-text-form-control
                [label]="i === 0 ? 'Naam deelneming' : ''"
                [required]=true
                class="custom-input-250"
                formControlName="naam"
                id="omschrijving"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-bsn-form-control
                [label]="i === 0 ? 'Fiscaal nummer' : ''"
                [required]=true
                class="custom-input-150"
                formControlName="fiscaalNummer"
                id="fiscaalNummer"
              >
              </snelstart-ui-bsn-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control
                [label]="i === 0 ? 'Perc. bezit' : ''"
                [required]=true
                [showAllDecimals]="true"
                align="right"
                class="custom-input-100"
                formControlName="percentageAandelenbezit"
                postfix="%"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control
                [label]="i === 0 ? 'Balanswaardering' : ''"
                [required]=true
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="balanswaardering"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-number-form-control
                [label]="i === 0 ? 'Voordelen deelneming' : ''"
                [required]=true
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="voordelenBoekjaar"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-button (click)="showDialog(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   icon="plus"
                                   type="secondary">Meer gegevens
              </snelstart-ui-button>
            </div>
            <div class="col-auto">
              <snelstart-ui-button
                (click)="verwijderRij(i)"
                [class]="i === 0 ? 'firstrowbutton' : ''"
                icon="trash"
                iconType="light"
                id="buttonDelete"
                size="medium"
                type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        </div>
      }
    </div>
  </form>

  <div>
    <snelstart-ui-button (click)="addRij()"
                         class="snelstart-ui-button pb-3"
                         icon="plus"
                         id="cancel"
                         type="link"
    >Deelneming toevoegen
    </snelstart-ui-button>
  </div>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="deelnemingGegevens" size="lg"
                                  title="Gegevens deelneming">
    <snelstart-ui-dialog-body>
      <div style="max-width: 90%">
        <form [formGroup]="deelnemingenFg">
          <div formArrayName="deelnemingen">
            @for (item of deelnemingen.controls; track item; let i = $index) {
              <div [formGroupName]="i">
                @if (i === index) {
                  @if (deelnemingen.controls[i]; as rowControl) {
                    <div class="row">
                      <div class="col col-1">
                        <p>Opgeofferd bedrag</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [required]=true
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-250"
                          formControlName="opgeofferdBedrag"
                          id="OpgeofferdBedrag"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col col-1">
                        <p>Vordering op deelneming</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-250"
                          formControlName="vorderingOpDeelneming"
                          id="vorderingOpDeelneming"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    @if (rowControl.get('vorderingOpDeelneming')?.getRawValue() !== null && rowControl.get('vorderingOpDeelneming')?.getRawValue() > 0) {
                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Ontvangen rente van deelneming</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-250"
                              formControlName="renteOntvangenVanDeelneming"
                              id="renteOntvangenVanDeelneming"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>
                    }

                    <div class="row">
                      <div class="col col-1">
                        <p>Schuld aan deelneming</p>
                      </div>
                      <div class="col-auto">
                        <snelstart-ui-number-form-control
                          [showAllDecimals]="false"
                          align="right"
                          class="custom-input-250"
                          formControlName="schuldAanDeelneming"
                          id="schuldAanDeelneming"
                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                      </div>
                    </div>

                    @if (rowControl.get('schuldAanDeelneming')?.getRawValue() !== null && rowControl.get('schuldAanDeelneming')?.getRawValue() > 0) {
                      <div>
                        <div class="row">
                          <div class="col col-1">
                            <p>Betaalde rente</p>
                          </div>
                          <div class="col-auto">
                            <snelstart-ui-number-form-control
                              [showAllDecimals]="false"
                              align="right"
                              class="custom-input-250"
                              formControlName="renteBetaaldAanDeelneming"
                              id="renteBetaaldAanDeelneming"
                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                          </div>
                        </div>
                      </div>
                    }

                    <div formGroupName="situatiesDeelneming">
                      <div class="row">
                        <div class="col col-1">
                          <p>Is de dochter dit boekjaar gevoegd of ontvoegd?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-250"
                            formControlName="dochterIsGevoegdofOntvoegd"
                            id="dochterIsGevoegdofOntvoegd"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      @if (rowControl.get('situatiesDeelneming')?.get('dochterIsGevoegdofOntvoegd')?.getRawValue() === true) {
                        <div>
                          <div class="row">
                            <div class="col col-1">
                              <p>Datum voeging</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-date-form-control
                                class="custom-input-250"
                                formControlName="voegingsdatum"
                                id="voegingsdatum"
                                label=""
                              >
                              </snelstart-ui-date-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Datum ontvoeging</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-date-form-control
                                class="custom-input-250"
                                formControlName="ontvoegingsdatum"
                                id="ontvoegingsdatum"
                                label=""
                              >
                              </snelstart-ui-date-form-control>
                            </div>
                          </div>
                        </div>
                      }

                      <div class="row">
                        <div class="col col-1">
                          <p>Is het belang vergroot in dit boekjaar?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-250"
                            formControlName="belangIsVerworvenOfVergroot"
                            id="belangIsVerworvenOfVergroot"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      @if (rowControl.get('situatiesDeelneming')?.get('belangIsVerworvenOfVergroot')?.getRawValue() === true) {
                        <div>
                          <div class="row">
                            <div class="col col-1">
                              <p>Percentage verwerking</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="percentageVerwerving"
                                placeholder="100,00"
                                postfix="%"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Nominale waarde verworven belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="nominaleWaardeVerworvenBelang"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Opgeofferd bedrag verworven belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="opgeofferdBedragVerworvenBelang"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Is het belang verworven van een verbonden persoon?</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-select-form-control
                                [options]="optionsJaNee"
                                class="custom-input-250"
                                formControlName="belangIsVerworvenVanVerbondenPersoon"
                                id="belangIsVerworvenVanVerbondenPersoon"
                              >
                              </snelstart-ui-select-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Voordelen uit verworven belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="brutoVoordelenVerworvenDeelneming"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Kosten verwerving van het belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="kostenVerwervingDeelneming"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>
                        </div>
                      }

                      <div class="row">
                        <div class="col col-1">
                          <p>Is het belang verkleind in dit boekjaar?</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-250"
                            formControlName="belangIsVerkochtOfVerkleind"
                            id="belangIsVerkochtOfVerkleind"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      @if (rowControl.get('situatiesDeelneming')?.get('belangIsVerkochtOfVerkleind')?.getRawValue() === true) {
                        <div>
                          <div class="row">
                            <div class="col col-1">
                              <p>Percentage vervreemding</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="percentageVervreemding"
                                postfix="%"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Nominale waarde vervreemde belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="nominaleWaardeVereemdeBelang"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Opbrengst vervreemde belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="opbrengstVervreemdeBelang"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>


                          <div class="row">
                            <div class="col col-1">
                              <p>Is het belang verkocht aan een verbonden persoon?</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-select-form-control
                                [options]="optionsJaNee"
                                class="custom-input-250"
                                formControlName="belangIsVervreemdAanVerbondenPersoon"
                                id="belangIsVervreemdAanVerbondenPersoon"
                              >
                              </snelstart-ui-select-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Voordelen uit vervreemde belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="brutoVoordelenVervreemdeDeelneming"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Kosten vervreemding van het belang</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="kostenVervreemdingDeelneming"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>
                        </div>
                      }

                      <div class="row">
                        <div class="col col-1">
                          <p>Is de dochter dit boekjaar geliquideerd</p>
                        </div>
                        <div class="col-auto">
                          <snelstart-ui-select-form-control
                            [options]="optionsJaNee"
                            class="custom-input-250"
                            formControlName="deelnemingIsGeliquideerd"
                            id="deelnemingIsGeliquideerd"
                          >
                          </snelstart-ui-select-form-control>
                        </div>
                      </div>

                      @if (rowControl.get('situatiesDeelneming')?.get('deelnemingIsGeliquideerd')?.getRawValue() === true) {
                        <div>
                          <div class="row">
                            <div class="col col-1">
                              <p>Datum vereffening (in boekjaar)</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-date-form-control
                                class="custom-input-250"
                                formControlName="vereffeningsdatum"
                                id="vereffeningsdatum"
                                label=""
                              >
                              </snelstart-ui-date-form-control>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col col-1">
                              <p>Liquidatieverlies</p>
                            </div>
                            <div class="col-auto">
                              <snelstart-ui-number-form-control
                                [showAllDecimals]="true"
                                align="right"
                                class="custom-input-250"
                                formControlName="liquidatieverlies"
                                prefix="€"
                              >
                              </snelstart-ui-number-form-control>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
        </form>
      </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
